<template>
  <table id="uploadFile-files" :class="['table bs3-vertical-center', {'hidden' : pUploadingFiles.length === 0}]"
         :data-next-index="pUploadingFiles.length">
    <thead>
    <tr>
      <th></th>
      <th>{{ 'dictionary.file.name' | i18nText(pDictionary) }}</th>
      <th>{{ 'dictionary.file.category' | i18nText(pDictionary) }}</th>
      <th class="width100Pixels"></th>
    </tr>
    </thead>
    <tbody>
    <file-upload-table-row
        v-for="(uploadingFile, index) in pUploadingFiles" :key="index"
        :p-file-data-form-input-name="pDataFormInputName"
        :p-index="index"
        :p-file="uploadingFile"
        :p-file-category-refs="fileCategoryRefs">
    </file-upload-table-row>
    </tbody>
  </table>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import FileUploadTableRow from "@/components/modules/file-module/file/upload/FileUploadTableRow";

export default {
  name: "FileUploadTable",
  components: {FileUploadTableRow},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pDataFormInputName: {
      type: String,
      default: function () {
        return 'dataForm';
      }
    },
    pUploadingFiles: {
      type: Array,
      required: true
    }
  },
  computed: {
    fileCategoryRefs: function () {
      return this.$store.state.filecategory.fileCategoryRefs;
    }
  },
  mounted: function () {
    this.$store.dispatch('filecategory/getFileCategoryRefs', {dataListInput: {}});
  }
}
</script>

<style scoped>

</style>